import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';
import { getProjects } from 'store/actions';
import MediaFile from 'Flow2/util/MediaFile';

const initialState = {
    loading: false,
    comments: {},
    clipTimeComments: {},
    clipTimeCurrent: {},
    clipTimeChanged: {},
    error: "",
    tab: ""
};

const setCommentList = (state, action) => {
    const comments = { ...state.comments };
    const clipId = action.payload.clipId;
    const projectId = action.payload.projectId;

    if (!comments.hasOwnProperty(clipId)) {
        comments[clipId] = {};
    }

    comments[clipId][projectId] = action.payload.comments.comment.elements;

    return updateObject(state, {
        comments: comments,
        loading: false
    });
}

const deleteCommentList = (state, action) => {
    const comments = { ...state.comments };
    const clipId = action.payload.clipId;
    const projectId = action.payload.projectId;

    if (comments.hasOwnProperty(clipId) && comments[clipId].hasOwnProperty(projectId)) {
        delete comments[clipId][projectId];
    }

    return updateObject(state, {
        comments: comments,
        loading: false
    });
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_COMMENTS_START:
            return updateObject(state, { loading: true });
        case actionTypes.GET_COMMENTS_FAIL:
            return updateObject(state, { loading: false });
        case actionTypes.GET_COMMENTS_SUCCESS:
            if (!Object.keys(action.payload.comments.comment.elements).length) {
                return deleteCommentList(state, action);
            }
            return setCommentList(state, action);
        case actionTypes.GET_CLIP_TIME_COMMENTS_SUCCESS:
            return updateObject(state, { clipTimeComments: action.payload })
        case actionTypes.SET_CLIP_TIME_CURRENT_SUCCESS:
            return updateObject(state, { clipTimeCurrent: action.payload });
        case actionTypes.CHANGE_CLIP_TIME_CURRENT_SUCCESS:
            return updateObject(state, { clipTimeChanged: action.payload });
        case actionTypes.SET_TIME_COMMENT_TAB:
            return updateObject(state, { tab: action.tab });
        default:
            return state;
    }
}

export default reducer;
